import Icon from '../components/Icon.vue'

Icon.register({
  'puzzle-piece': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M519.4 288.7C477.9 288.7 459.9 320.2 437.4 320.2 377.4 320.2 432 144 432 144S235.7 224 235.7 140.7C235.7 104.9 272 94.5 272 54.7 272 19.2 243.9 0 210.5 0 175.9 0 144.2 18.9 144.2 56.3 144.2 97.7 175.9 115.6 175.9 138.1 175.9 207.7 0 166.8 0 166.8V500S178.6 541 178.6 471.3C178.6 448.9 138.6 431.2 138.6 389.9 138.6 352.4 167.9 333.5 202.2 333.5 235.9 333.5 264 352.7 264 388.2 264 428 227.7 438.4 227.7 474.2 227.7 535 357.4 499.9 408.9 499.9 408.9 499.9 374.2 379.8 434.8 379.8 470.7 379.8 481.2 416 521.1 416 556.7 416 576 388 576 354.4 576 320.2 557 288.7 519.4 288.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/puzzle-piece.js
// module id = g9V7
// module chunks = 144